import type { NamedFieldProps } from "./Field.js";
import { StringSchema, getSource } from "shelving";
import { Field, useField } from "./Field.js";
import { FieldNotice } from "./FieldNotice.js";

type TextCompleteType =
	| "on"
	| "off"
	| "name"
	| "honorific-prefix"
	| "given-name"
	| "additional-name"
	| "family-name"
	| "honorific-suffix"
	| "nickname"
	| "username"
	| "new-password"
	| "current-password"
	| "one-time-code"
	| "organization-title"
	| "organization"
	| "street-address"
	| "address-line1"
	| "address-line2"
	| "address-line3"
	| "address-level4"
	| "address-level3"
	| "address-level2"
	| "address-level1"
	| "country"
	| "country-name"
	| "postal-code"
	| "cc-name"
	| "cc-given-name"
	| "cc-additional-name"
	| "cc-family-name"
	| "cc-number"
	| "cc-exp"
	| "cc-exp-month"
	| "cc-exp-year"
	| "cc-csc"
	| "cc-type"
	| "transaction-currency"
	| "transaction-amount"
	| "language"
	| "bday"
	| "bday-day"
	| "bday-month"
	| "bday-year"
	| "sex"
	| "url";

export function TextField({
	autocomplete = "off",
	spellCheck = true,
	disabled = false,
	...props
}: {
	spellCheck?: boolean;
	autocomplete?: TextCompleteType;
	disabled?: boolean;
} & NamedFieldProps): React.ReactElement {
	const field = useField<string>(props);
	const { name, form, schema, fullplaceholder, value } = field;
	const { type, min, max } = getSource(StringSchema, schema);
	const onValue: React.FormEventHandler<HTMLInputElement> = ({ currentTarget }) => form.publish(name, currentTarget.value);
	return (
		<Field {...field}>
			<input
				name={name}
				type={type}
				inputMode={type === "tel" || type === "email" || type === "url" ? type : "text"}
				className="input space-none"
				placeholder={fullplaceholder}
				defaultValue={type !== "password" ? value : undefined}
				required={min > 0}
				maxLength={max}
				spellCheck={spellCheck}
				autoComplete={autocomplete}
				disabled={disabled}
				onInput={onValue}
				onChange={onValue}
			/>
			<FieldNotice name={name} />
		</Field>
	);
}
